// extracted by mini-css-extract-plugin
export default {"block":"block__eAIzC","block__label":"block__label__ygj3f"};